import * as Yup from "yup";

export const ServiceBookingSchema = Yup.object().shape({
  phone_number: Yup.string()
    .required("Це поле повинно бути заповнене")
    .test("phone-format", "Невірний формат телефону для обраної країни", function (
      value
    ) {
      // PhoneSelect сам звіряє номер з форматом країни (react-phone-input-2) і
      // пише результат у phone_number_valid. Якщо значення прийшло не через
      // PhoneSelect (напр. автозаповнення з бази по держномеру), покладаємось
      // на м'яку перевірку довжини.
      const { phone_number_valid } = this.parent;
      if (typeof phone_number_valid === "boolean") {
        return phone_number_valid;
      }

      const digits = (value || "").replace(/\D/g, "");
      return digits.length >= 8 && digits.length <= 15;
    }),
  car_number: Yup.string()
    .matches(
      /^[a-zA-Z0-9]+$/,
      "Поле має містити цифри та латинські літери без пробілів"
    )
    .required("Це поле повинно бути заповнене"),
  vin: Yup.string().matches(
    /^[a-zA-Z0-9]+$/,
    "Поле повинно містити лише латинські літери та цифри"
  ),
  service_id: Yup.string().required("Це поле повинно бути заповнене"),
  // prepayment: Yup.number().typeError("Це поле повинно бути числом"),
  service_type: Yup.array().min(1, "Оберіть хоча б одну послугу"),
  position: Yup.string().required("Це поле повинно бути заповнене"),
  mechanic_id: Yup.string().required("Це поле повинно бути заповнене"),
  name: Yup.string().required("Це поле повинно бути заповнене"),
  model: Yup.string()
    //   .matches(
    //   /^[a-zA-Z0-9 ]+$/,
    //   "Поле повинно містити лише латинські літери та цифри"
    // ),
    .required("Це поле повинно бути заповнене"),
  make: Yup.string()
    // .matches(
    //   /^[a-zA-Z0-9 ]+$/,
    //   "Поле повинно містити лише латинські літери та цифри"
    // )
    .required("Це поле повинно бути заповнене"),
  year: Yup.string(),
  // .required("Це поле повинно бути заповнене")
  note: Yup.string(),
});
